import { axios } from '@/utils/request'

const api = {
  master: '/master/teamList',
  report: '/master/statisticalReport/statisticalInfoList'
}

// 团队下拉框
export function teamList (parameter) {
  return axios({
    url: api.master + '/get',
    method: 'get',
    params: parameter
  })
}

// 师傅考核报表
export function MasterAppraisalForm (parameter) {
  return axios({
    url: api.report,
    method: 'post',
    data: parameter
  })
}
